import React, { useEffect, useState, useContext } from "react";
import "./Login.css";
import loginScreenLight from "../../assets/images/loginScreenLight.svg"
import loginScreenDark from "../../assets/images/LoginScreenDark.svg"
import homeLogo1 from "../../assets/images/homeLogo.svg"
import useStartSession from "../../hooks/useStartSession";
import { encrypted } from "../../utils/Utility";
import { ThemeContext } from "../../contexts/ThemeContext";
import { fetchPolicySign } from "../../store/apiActions";

import {
  useDispatch,
  useSelector,
} from "react-redux";
import { fetchLoggedInDetails } from "../../store/apiActions";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { env } from "../../environment";
function Login() {
  // const dispatch = useDispatch();
  const loggedInDetails = useSelector((state) => state.api.loggedInDetails);
  const [loginState, setLoginState] = useState(false);
  const startSession = useStartSession();
  const dispatch = useDispatch();
  const { isDarkMode } = useContext(ThemeContext);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    checkAndLoginUser();
    // eslint-disable-next-line
  }, [location.search]);

  useEffect(() => {
    userDetails();
  }, []);

  const checkAndLoginUser = () => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    const error = queryParams.get("error");
    if (code) {
      setLoginState(true);
      fetchUserTokenAndAuthenticate(code);

    } else if (error) {
      // Handle the error, e.g., show an error message
    }
  };

  const fetchUserTokenAndAuthenticate = async (code) => {
    setLoginState(true); // Set loading state before making the request
    try {
      const response = await axios.post(`${env.baseURL}/auth/azure/authenticate`, {
        encryptedBody: encrypted.encrypt(JSON.stringify({ code: code })),
      });
      let item = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
      const encryptedUser = encrypted.encrypt(JSON.stringify(item.app_user));
      localStorage.setItem("token", item.token);
      localStorage.setItem("LoggedInDetails", encryptedUser);
      encrypted.setEncryptedItem(
        "isLogin", true);
      await startSession();
      await policyCheck();
      setLoginState(false);
      navigate("/home");
      setTimeout(() => {
        toast.success("You are successfully logged in");
      }, 200);  
   
    } catch (error) {
      setLoginState(false); // Reset login state on error
      toast.error(error.message);
    } finally {
      setLoginState(false); // Ensure the loading state is reset
    }
  };
  const policyCheck = async () => {
    try {
      const details = JSON.parse(encrypted.decrypt(localStorage.getItem("LoggedInDetails")));
  
      if (!details || !details.username) {
        toast.error("User details not found. Please log in again.");
        navigate("/login");
        return;
      }
      const url = `${env.baseURL}/check-policy-popup`;
      const policyResponse = await dispatch(fetchPolicySign(url));
      localStorage.setItem("isPolicy", policyResponse);
      return policyResponse;
    } catch (error) {
      console.error("Error fetching policy:", error);
      toast.error("Failed to fetch policy.");
    }
  };

  const userDetails = () => {
    fetchLoggedInDetails(`${env.baseURL}/app-user-profile`);
  };

  useEffect(() => {
    if (loggedInDetails) {
      //  const userDetails = {dropdown:loggedInDetails?.data?.appUserRoleMappings[0],role:loggedInDetails?.data?.role};
      //  localStorage.setItem("loggedInDetails", JSON.stringify(userDetails));
    }
  }, [loggedInDetails]);

  const fetchAuthenticatedAPI = () => {
    axios
      .get(`${env.baseURL}/auth/azure/auth-info`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        let data = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
        ssoSignIn(data);
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  };

  const ssoSignIn = (props) => {
    const item = props;
    const loginUrl = item.login_url;
    const logOutUrl = item.logout_url;
    if (loginUrl) {
      encrypted.setEncryptedItem(
        "loginUrl", loginUrl);
      window.location.href = loginUrl;
    }
    if (logOutUrl) {
      encrypted.setEncryptedItem(
        "logOutUrl", logOutUrl);
    }
  };

  return (
    <>
      <ToastContainer closeButton={true} position="top-right" />
      {!loginState ? (
        <div
          style={{
            backgroundImage: `url(${isDarkMode ? loginScreenDark : loginScreenLight})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100%",
            overflow: "hidden",
          }}
        >
          <div className="parentLoginContainer">
            <div className="parentTextContainer">
              <div
                className={`textContainer ${isDarkMode ? "dark-mode" : "light-mode"}`}
              >
                <div
                  className={`welcome-text ${isDarkMode ? "dark-mode" : "light-mode"}`}
                >
                  Welcome to
                </div>
                <div className="login-logo">
                  <img src={homeLogo1} alt="Home Logo" />
                </div>
                <div
                  className={`loginTo ${isDarkMode ? "dark-mode" : "light-mode"}`}
                >
                  <span>Log in to continue</span>
                </div>
                <div className="loginButtonContainer">
                  <button
                    className="buttonAlignment"
                    onClick={fetchAuthenticatedAPI}
                  >
                    Login
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={`loginWaitContainer ${isDarkMode ? "dark-mode" : "light-mode"}`}>
          <div className="spinner"></div>
          <span className={`wait-message ${isDarkMode ? "dark-mode" : "light-mode"}`}>Please wait while we log you in...</span>
        </div>
      )}
    </>
  );
}

export default Login;
